function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1443 2.24346L31.4511 21.8667C31.7 22.4524 31.8088 22.9287 31.8399 23.4234C31.9022 24.5795 31.4978 25.7031 30.7046 26.5678C29.9114 27.4295 28.8383 27.9381 27.6718 27.9998H4.90271C4.42058 27.9705 3.93844 27.861 3.48742 27.6915C1.23228 26.7821 0.143591 24.2234 1.0612 22.0054L12.4458 2.22959C12.8346 1.53443 13.4256 0.934835 14.1566 0.549492C16.2717 -0.623491 18.9623 0.147194 20.1443 2.24346ZM17.6402 15.1755C17.6402 15.9154 17.0337 16.5334 16.2872 16.5334C15.5406 16.5334 14.9185 15.9154 14.9185 15.1755V10.815C14.9185 10.0736 15.5406 9.47397 16.2872 9.47397C17.0337 9.47397 17.6402 10.0736 17.6402 10.815V15.1755ZM16.2872 21.8051C15.5406 21.8051 14.9185 21.187 14.9185 20.4487C14.9185 19.7073 15.5406 19.0908 16.2872 19.0908C17.0337 19.0908 17.6402 19.6934 17.6402 20.4318C17.6402 21.187 17.0337 21.8051 16.2872 21.8051Z",
  fill: "#FFB800"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9aa78c1c.svg";
export { ForwardRef as ReactComponent };